"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ControlMessage_1 = __importDefault(require("../ControlMessage"));
const validations_1 = require("../../../utils/validations");
class ResendLastRequest extends ControlMessage_1.default {
    constructor({ version = ControlMessage_1.default.LATEST_VERSION, requestId, streamId, streamPartition, numberLast, sessionToken }) {
        super(version, ControlMessage_1.default.TYPES.ResendLastRequest, requestId);
        validations_1.validateIsNotEmptyString('streamId', streamId);
        validations_1.validateIsNotNegativeInteger('streamPartition', streamPartition);
        validations_1.validateIsNotNegativeInteger('numberLast', numberLast);
        validations_1.validateIsString('sessionToken', sessionToken, true);
        this.streamId = streamId;
        this.streamPartition = streamPartition;
        this.numberLast = numberLast;
        this.sessionToken = sessionToken;
        validations_1.validateIsNotEmptyString('requestId', requestId); // unnecessary line once V1 is dropped
    }
}
exports.default = ResendLastRequest;
//# sourceMappingURL=ResendLastRequest.js.map